import { createAsyncThunk } from '@reduxjs/toolkit'
import { SCREEN } from '../../../../../../common/selectCurrencyUnit/constant'
import { calculateDefaultUnit } from '../../../../../../common/selectCurrencyUnit/slice'
import { handleExport } from '../../../../../../helpers/export'
import FinancialAnalysisService from '../../../core/service'
import { mapAllVNDValue } from '../../../helper'

const screen = SCREEN.FINANCIAL_ANALYSIS

export const getNonBankAverageCostThunk = createAsyncThunk(
  'financialAnalysis/NonBank/getBankAverageCost',
  async (data, { rejectWithValue, dispatch }) => {
    const response = await FinancialAnalysisService.getAverageCost(data)
    if (response.success) {
      const getValues = () => mapAllVNDValue(response.data)
      dispatch(calculateDefaultUnit({ screen, getValues }))
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const downloadNonBankAverageCost = createAsyncThunk(
  'financialAnalysis/NonBank/downloadBankAverageCost',
  async (data) => {
    const response = await FinancialAnalysisService.downloadAverageCost(data)
    handleExport(response.data, response.filename)
  },
)
